import { render, staticRenderFns } from "./atkmtrx.vue?vue&type=template&id=5b2a06ea&scoped=true&"
import script from "./atkmtrx.vue?vue&type=script&lang=js&"
export * from "./atkmtrx.vue?vue&type=script&lang=js&"
import style0 from "./atkmtrx.vue?vue&type=style&index=0&id=5b2a06ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a06ea",
  null
  
)

export default component.exports